import { Route } from 'react-router-dom'
import { Studio3DLayout } from './layouts/Studio3DLayout'
import { Studio3DScreen } from './screens/Studio3DScreen'
import { GuestGalleryLayout } from './layouts/GuestGalleryLayout'
import { GuestGalleryScreen } from './screens/GuestGallery'
import { VirtualSpacesVisionScreen } from './screens/VirtualSpacesVision'
import { PresentRealisticScreen } from './screens/PresentRealistic'
import { SpacesStudioScreen } from './screens/SpacesStudio'
import { MountainLotScreen } from './screens/MountainLot'

/**
 * Gallery Studio 3D route — the Figma-grade Babylon editor, now the live
 * `/galleries/:galleryId/studio` owner editor (promoted from its old
 * `studio-next` path once it replaced the legacy 2D `gallery-studio`
 * editor — see `album/routes.tsx` for why that one's unmounted, not
 * deleted). Nested under the same `AlbumDesignRoot` (auth + design system
 * provider) the legacy studio used, so auth works identically.
 *
 * /galleries/:galleryId/studio
 * /galleries/:galleryId/virtual-spaces      — Spaces vision mock (gallery → living space)
 * /galleries/:galleryId/present-realistic   — walkable-hall Present fidelity target
 * /galleries/:galleryId/spaces-studio       — furniture placement prototype (bedroom/studio/living room)
 * /galleries/:galleryId/mountain-lot         — walkable glass-walled lot prototype (WASD, mountain vista)
 */
export const galleryStudio3DRouteElements = (
  <>
    <Route path='galleries/:galleryId/studio' element={<Studio3DLayout />}>
      <Route index element={<Studio3DScreen />} />
    </Route>
    <Route path='galleries/:galleryId/virtual-spaces' element={<Studio3DLayout />}>
      <Route index element={<VirtualSpacesVisionScreen />} />
    </Route>
    <Route path='galleries/:galleryId/present-realistic' element={<Studio3DLayout />}>
      <Route index element={<PresentRealisticScreen />} />
    </Route>
    <Route path='galleries/:galleryId/spaces-studio' element={<Studio3DLayout />}>
      <Route index element={<SpacesStudioScreen />} />
    </Route>
    <Route path='galleries/:galleryId/mountain-lot' element={<Studio3DLayout />}>
      <Route index element={<MountainLotScreen />} />
    </Route>
  </>
)

/**
 * Public guest render — mirrors `a/:shareId` (see album/routes.tsx): sits
 * OUTSIDE `AlbumDesignRoot`, no auth gate, own Axios+design-system layout.
 * `shareId` is the raw `topicID` (same non-decision albums already made —
 * see usePublicGallery's doc comment).
 *
 * /g/:shareId
 */
export const galleryGuestRouteElements = (
  <Route path='g/:shareId' element={<GuestGalleryLayout />}>
    <Route index element={<GuestGalleryScreen />} />
  </Route>
)
